export default __webpack_public_path__ + "static/media/single-line-blackboard-high.1609531c.jpg";